import Vue from 'vue'

/**
 * 粉丝可见关注弹窗的跨页面控制器
 *
 * 使用方式：
 * 1. 在页面根组件中挂载 <FollowFansDialog />
 * 2. 任意组件/页面内调用 FollowFansDialog.show({
 *      avatar, nickname, l_id,
 *      onSuccess: ({ l_id }) => { ... }
 *    })
 */
const bus = new Vue()

export const FollowFansDialog = {
    show(payload) {
        bus.$emit('show', payload)
    },
    hide() {
        bus.$emit('hide')
    },
    onShow(callback) {
        bus.$on('show', callback)
    },
    offShow(callback) {
        bus.$off('show', callback)
    },
    onHide(callback) {
        bus.$on('hide', callback)
    },
    offHide(callback) {
        bus.$off('hide', callback)
    },
    // 关注成功事件：用于跨页面同步关注状态
    followSuccess(payload) {
        bus.$emit('follow-success-bus', payload)
    },
    onFollowSuccess(callback) {
        bus.$on('follow-success-bus', callback)
    },
    offFollowSuccess(callback) {
        bus.$off('follow-success-bus', callback)
    }
}
